var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9986 2.67157C13.9986 3.73244 13.5772 4.74985 12.827 5.5C12.0769 6.25015 11.0595 6.67157 9.99861 6.67157C8.93775 6.67157 7.92033 6.25015 7.17018 5.5C6.42004 4.74985 5.99861 3.73244 5.99861 2.67157M1.63183 4.40138L0.93183 12.8014C0.781453 14.6059 0.706265 15.5082 1.0113 16.2042C1.2793 16.8157 1.74364 17.3204 2.3308 17.6382C2.99908 18 3.90447 18 5.71525 18H14.282C16.0928 18 16.9981 18 17.6664 17.6382C18.2536 17.3204 18.7179 16.8157 18.9859 16.2042C19.291 15.5082 19.2158 14.6059 19.0654 12.8014L18.3654 4.40138C18.236 2.84875 18.1713 2.07243 17.8275 1.48486C17.5247 0.967441 17.0739 0.552603 16.5331 0.293846C15.919 1.16229e-06 15.14 1.04037e-06 13.582 8.54636e-07L6.41525 2.95586e-10C4.85724 -1.85434e-07 4.07823 -2.98023e-07 3.46413 0.293844C2.92336 0.552601 2.47251 0.96744 2.16974 1.48486C1.82591 2.07243 1.76122 2.84875 1.63183 4.40138Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag0);
export default __webpack_public_path__ + "static/media/shopping-bag0.87d4bfff1a70270e2d3745882f804c20.svg";
export { ForwardRef as ReactComponent };